import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {List} from 'immutable';
import { jsxActions as headerActions} from '../../../actions/Header/headerActions';
import { jsxActions as fetchEntitiesActions }      from '../../../actions/FetchEntities/fetchEntitiesActions.js';
import { jsxActions as assetsViewActions }        from '../../../actions/LocationPage/AssetsView/assetsViewActions';
import { jsxActions as assetsGroupsGridActions }  from '../../../actions/LocationPage/AssetsView/assetsGroupsGridActions';
import { gridsNames} from '../../../enums/gridsNames';
import GroupsView from '../../../components/LocationPage/AssetsView/GroupsView/groupsView';

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      ...bindActionCreators(assetsViewActions, dispatch),
      fetchEntitiesActions:    bindActionCreators(fetchEntitiesActions, dispatch),
      headerActions:        bindActionCreators(headerActions, dispatch),
      assetsGroupsGridActions:        bindActionCreators(assetsGroupsGridActions, dispatch),
    }
  }
}

let GroupsViewContainer = connect(
  (state) => {
    let sGrid = state.grid.get(gridsNames.LOCATION_ASSET_GROUPS) ? state.grid.get(gridsNames.LOCATION_ASSET_GROUPS) : null;
    return {
      sGrid:                  sGrid,
      sHasRows:               sGrid && sGrid.get('rows') ? sGrid.get('rows').size > 0 : false,
      sSelectedRowsData:      sGrid ? sGrid.get('selectedRowsData') : List(),
      sData:                  state.locationPage.getIn(['assetsView', 'groupsView']),
      sLocationDetails:       state.locationPage.get('data').get('locationDetails'),
      sLoggedInUser :         state.login.get('loggedInUser'),
    };
  },
  mapDispatchToProps
)(GroupsView);

export default GroupsViewContainer;




